import { useTranslation } from 'react-i18next';
import EXTERNAL_URLS from 'constants/externalUrls';
import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import NavTabs from 'components/NavTabs/NavTabs';
import BrandInformation from 'views/BrandConfiguration/BrandInformation';
import makeStyles from '@material-ui/styles/makeStyles';

import TermsAndConsents from './TermsAndConsents/TermsAndConsents';

const useStyles = makeStyles({
  tooltipWrapper: { flexGrow: 9999, height: '20px' },
});

const DataAndConsentsContent = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <NavTabs
      tabs={[
        {
          tabButton: t('brandCfg.brandData'),
          tabContent: <BrandInformation isEdit={true} />,
        },
        {
          tabButton: t('brandCfg.termsAndConsents'),
          tabContent: <TermsAndConsents />,
        },
      ]}
      contentAfterTabButtons={
        <div className={classes.tooltipWrapper}>
          <InfoWithTooltip
            title={t('brandCfg.dataAndConsentsInfo', {
              menuItem: t('common.mainMenu.brandConfiguration.dataAndConsents'),
            })}
            link={EXTERNAL_URLS.information}
          />
        </div>
      }
    />
  );
};

export default DataAndConsentsContent;
